import Popper from 'popper.js';

//

var script = {
  name: 'PtTooltip',
  props: {
    content: {
      type: String,
      default: '',
      description: 'Content to show in tooltip, tooltip won\'t be shown if content is empty',
    },
    disableOutsideClick: {
      type: Boolean,
      default: false,
      description: 'Disable hiding tooltip on outside click. Only valid if trigger is set to `click`',
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    trigger: {
      type: String,
      default: 'hover',
      validator: function validator(value) {
        return ['hover', 'click'].indexOf(value) !== -1;
      },
      description: 'Trigger event for tooltip. Possible values are `hover`, `click`',
    },
  },
  data: function data() {
    return {
      refElement: null,
      showTooltip: false,
      tooltipInstance: null,
    };
  },
  watch: {
    showTooltip: function showTooltip(value) {
      if (value) {
        this.createOrUpdateTooltip();
      }
    },
  },
  mounted: function mounted() {
    this.refElement = this.$slots.default[0].elm;

    switch (this.trigger) {
      case 'click':
        this.refElement.addEventListener('click', this.doToggle);
        document.addEventListener('click', this.handleDocumentClick);
        break;
      case 'hover':
      default:
        this.refElement.addEventListener('mouseover', this.show);
        this.refElement.addEventListener('mouseout', this.hide);
        break;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.refElement) {
      this.refElement.removeEventListener('click', this.doToggle);
      this.refElement.removeEventListener('mouseover', this.show);
      this.refElement.removeEventListener('mouseout', this.hide);
    }

    document.removeEventListener('click', this.handleDocumentClick);

    if (this.tooltipInstance && this.tooltipInstance.destroy) {
      this.tooltipInstance.destroy();
      this.tooltipInstance = null;
    }

    this.refElement = null;
  },
  methods: {
    createOrUpdateTooltip: function createOrUpdateTooltip() {
      if (this.tooltipInstance) {
        this.tooltipInstance.scheduleUpdate();
      } else {
        this.createTooltipInstance();
      }
    },
    createTooltipInstance: function createTooltipInstance() {
      var tooltipElement = this.$refs.tooltip;
      var options = {
        placement: this.placement,
        modifiers: {
          arrow: {
            enabled: true,
            element: this.$refs.arrow,
          },
        },
        positionFixed: true,
      };

      this.tooltipInstance = new Popper(this.refElement, tooltipElement, options);
    },
    doToggle: function doToggle(e) {
      // User may want to show/hide programmatically
      if (e.defaultPrevented) { return; }

      this.toggle();
    },
    handleDocumentClick: function handleDocumentClick(event) {
      // We don't want to handle this if tooltip is hidden
      if (!this.showTooltip) { return; }

      if ((this.refElement && this.refElement.contains(event.target)) ||
          this.$refs.tooltip.contains(event.target) ||
          this.disableOutsideClick) {
        return;
      }

      this.showTooltip = false;
    },
    show: function show() {
      if (this.content || this.$slots.content) {
        this.showTooltip = true;
      }
    },
    hide: function hide() {
      this.showTooltip = false;
    },
    toggle: function toggle() {
      if (this.content || this.$slots.content) {
        this.showTooltip = !this.showTooltip;
      }
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTooltip,
                expression: "showTooltip"
              }
            ],
            ref: "tooltip",
            staticClass: "pt-tooltip"
          },
          [
            _c(
              "div",
              { staticClass: "pt-tooltip-inner" },
              [
                _vm._t("content", [
                  _vm._v(
                    "\n            " + _vm._s(_vm.content) + "\n          "
                  )
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { ref: "arrow", staticClass: "pt-tooltip-arrow" })
          ]
        )
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Tooltip = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export { Tooltip as PtTooltip };
